<syndicated-header class="header" *ngIf="useSyndicated">
</syndicated-header>
<main appUniversalResources>
  <pixie-homepage></pixie-homepage>
  <router-outlet></router-outlet>
</main>
<syndicated-footer class="footer" *ngIf="useSyndicated">
</syndicated-footer>
<font-icon-loader></font-icon-loader>
